import React, { useState, useEffect } from "react";
import { Box, Typography } from "@material-ui/core";

import Header from "../../components/Header";
import IconFilters from "./components/IconFilters";
import { SocialPlatforms } from "../../constants/SocialPlatforms";
import { roundTime } from "../../utils/time";
import { useQuery } from "@apollo/react-hooks";
import { listShows } from "../../graphql/queries";
import { gql } from "apollo-boost";
import { getTwitchBearer } from "../../services/getTwitchBearer";
import { getTwitchStreams } from "../../services/getTwitchStreams";
import { getLiveStreamsSearch } from "../../services/getLiveStreamsSearch";
import { getLiveStreamsPlaylist } from "../../services/getLiveStreamsPlaylist";
import StreamingNow from "./components/StreamingNow";
import { Analytics } from "aws-amplify";

export interface Show {
  user: {
    username: string;
    user_id: string;
    photo: string;
  };
  title?: string;
  videoUrl?: string;
  platform: SocialPlatforms;
  time: {
    start: Date;
    end?: Date;
  };
}

const ListingsPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [, setCurrentTime] = useState(new Date());
  const [shows, setShows] = useState<Show[]>([]);
  const [filter, setFilter] = useState<SocialPlatforms | undefined>();
  const [tB, settB] = useState<string>();
  const [yt, setYt] = useState<boolean>(false);

  useGetShows(setShows, setLoading, loading);

  useEffect(() => {
    Analytics.record({ name: "pageVisit" });
  }, []);

  useEffect(() => {
    async function initTwitch() {
      const bearer = await getTwitchBearer();

      settB(bearer);
    }
    initTwitch();
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/api.js";

    script.onload = () => {
      const gapi = (window as any).gapi;
      gapi.load("client", () => {
        gapi.client.setApiKey("AIzaSyA1UGdQNcf9W79ipmNRdU1Re0gnO2knfmM");
        gapi.client
          .load("https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest")
          .then(
            function () {
              console.log("GAPI client loaded for API");
              setYt(true);
            },
            function (err: any) {
              console.error("Error loading GAPI client for API", err);
            }
          );
      });
    };

    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (yt) {
      getLiveStreamsSearch().then(
        function (response: any) {
          setShows((shows) => {
            return [
              ...shows,
              ...response.result.items.map((i: any) => {
                return {
                  user: {
                    userId: i.snippet.channelId,
                    username: i.snippet.channelTitle,
                    photo: i.snippet.thumbnails.medium.url,
                  },
                  title: i.snippet.title,
                  platform: "yt",
                  videoUrl: "https://www.youtube.com/watch?v=" + i.id.videoId,
                  time: {
                    start: roundTime(new Date(i.snippet.publishedAt)),
                  },
                };
              }),
            ];
          });
        },
        function (err: any) {
          console.error("Execute error", err);
        }
      );

      getLiveStreamsPlaylist().then(
        function (response: any) {
          setShows((shows) => {
            return [
              ...shows,
              ...response.result.items.map((i: any) => {
                return {
                  user: {
                    userId: i.snippet.channelId,
                    username: i.snippet.channelTitle,
                    photo: i.snippet.thumbnails.medium.url,
                  },
                  title: i.snippet.title,

                  videoUrl:
                    "https://www.youtube.com/watch?v=" +
                    i.contentDetails.videoId,

                  platform: "yt",
                  time: {
                    start: roundTime(
                      new Date(i.contentDetails.videoPublishedAt)
                    ),
                  },
                };
              }),
            ];
          });
        },
        function (err: any) {
          console.error("Execute error", err);
        }
      );
    }
  }, [yt]);

  useEffect(() => {
    async function test() {
      if (tB) {
        const streams = await getTwitchStreams(tB);

        setShows((shows) => {
          return [
            ...shows,
            ...streams.map((i: any) => {
              return {
                user: {
                  userId: i.user_id,
                  username: i.user_name,
                  photo: i.thumbnail_url
                    .replace("{width}", 640)
                    .replace("{height}", 360),
                },
                title: i.title,

                platform: "tw",
                time: {
                  start: roundTime(new Date(i.started_at)),
                },
              };
            }),
          ];
        });
      }
    }

    test();
  }, [tB]);

  const filteredShows = filter
    ? shows.filter((show) => show.platform === filter)
    : shows;

  const sorted = filteredShows.sort(
    (a, b) => b.time.start.valueOf() - a.time.start.valueOf()
  );

  return (
    <>
      <Header />
      <main>
        <IconFilters
          onFilterSelected={(f) => {
            Analytics.record({
              name: "filterShows",
              attributes: {
                platform: f || "all",
              },
            });

            setFilter(f);
          }}
          selectedFilter={filter}
        />
        <Box textAlign="center" paddingTop={5}>
          <Typography variant="h4">Currently Streaming</Typography>
        </Box>
        <StreamingNow shows={sorted} />
        {/* <Box
          display="flex"
          justifyContent="space-around"
          borderBottom="1px solid #f0f0f0"
        >
          <Button size="large" fullWidth style={{ flex: 1 }} onClick={getPrev}>
            <FontAwesomeIcon
              icon={faArrowLeft}
              size="lg"
              style={{ marginRight: "16px" }}
            />{" "}
            Previous
          </Button>
          <Box flex={1} textAlign="center" alignSelf="center" padding={2}>
            <Typography variant="h3" style={{ fontSize: "18px" }}>
              {currentTime.toDateString()}
            </Typography>
          </Box>
          <Button size="large" fullWidth style={{ flex: 1 }} onClick={getNext}>
            Next{" "}
            <FontAwesomeIcon
              icon={faArrowRight}
              size="lg"
              style={{ marginLeft: "16px" }}
            />
          </Button>
        </Box>
        {loading ? (
          <div>Loading</div>
        ) : (
          // <ShowList shows={filteredShows} displayedTime={currentTime} />
       
        )} */}
      </main>
    </>
  );
};

export default ListingsPage;

export function useGetShows(
  setShows: React.Dispatch<React.SetStateAction<Show[]>>,
  setLoading: React.Dispatch<boolean>,
  currentLoading: boolean
) {
  const { loading, data } = useQuery(gql(listShows), {
    variables: {
      filter: {},
    },
  });

  useEffect(() => {
    if (currentLoading !== loading) {
      setLoading(loading);
    }
  }, [currentLoading, loading, setLoading]);

  useEffect(() => {
    if (data && data.listShows) {
      setShows((shows: Show[]) => [
        ...shows,
        ...data.listShows.items.map(
          (i: any) =>
            ({
              platform: i.platform,
              user: {
                username: i.username,
              },
              time: { start: roundTime(new Date(i.timeStart)) },
            } as Show)
        ),
      ]);
    }
  }, [data, setShows]);
}
